/*=========================================================================================
  File Name: moduleRoleActions.js
  Description: Role Module Actions
==========================================================================================*/

import roleGql from "@/http/requests/link/role_gql.js";
import role_gql from "../../http/requests/link/role_gql";

export default {
	toggleRolesCategorySideBar({ commit }, payload) {
		commit("SET_ROLE_CATEGORY_SIDEBAR_STATUS", payload.status);
	},
	updateRole({ commit }, payload) {
		return new Promise((resolve, reject) => {
			role_gql
				.updateRole(payload)
				.then(response => {
					commit("UPDATE_ROLE", response.role_update);
					resolve(response.role_update);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_ROLES", false);
					reject(error);
				});
		});
	},

	addRole({ commit }, payload) {
		return new Promise((resolve, reject) => {
			role_gql
				.addRole(payload)
				.then(response => {
					commit("ADD_NEW_ROLE", response.role_add);
					resolve(response.role_add);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_ROLES", false);
					reject(error);
				});
		});
	},

	deleteRole({ commit }, payload) {
		return new Promise((resolve, reject) => {
			role_gql
				.deleteRole(payload)
				.then(response => {
					commit("DELETE_ROLE", payload);
					resolve(response.role_delete);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_ROLES", false);
					reject(error);
				});
		});
	},
	fetchRoles({ commit }, payload) {
		return new Promise((resolve, reject) => {
			roleGql
				.fetchRoles(payload)
				.then(response => {
					commit("SET_ROLES", response.roles.data);
					commit("SET_TOTAL_ROLES", response.roles.total);

					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	fetchModuleRoles({ commit }) {
		return new Promise((resolve, reject) => {
			role_gql
				.fetchModuleRoles({})
				.then(response => {
					commit("SET_MODULE_ROLES", response.module_roles);
					resolve(response.module_roles);
				})
				.catch(error => {
					reject(error);
				});
		});
	}
};
